export abstract class CategorizedError<T = void> {

  constructor(public title: string, public description: string, public data?: T) { }

  abstract handle<T>(shouldNotify: boolean): void;
}